// extracted by mini-css-extract-plugin
export default {"banner":"banner-module_banner__LkFgpt1","header":"banner-module_header_PZ1DgbiT","sub-header":"banner-module_sub-header_qvKrZAxp"};